// 軸 6 archetype 4 (`cooldown-reduction`) CD layer 集計。ADR 0015 §4.3 / §7.3。
//
// 装備スキル軸 6 archetype 4 (`cooldown-reduction`) の catalogue Skill object は
// `Skill.cdrRate?: number` フィールドで base 値を埋め込み、Tier 個体差は
// `ItemSkill.values[tier]` で上書きする。集計関数は `entity.itemSkills` 走査で
// `templateId` → Skill lookup → `cdrRate` を取得 + values[tier] 優先で合算する。
//
// 合計は `applyCooldownRateMod` の `layers.axis6` に渡され、
// `affix + axis6 + other` 合計 30% でクランプされる (cd-clamp.ts)。
// 個別 layer 自体に上限はかけない (catalogue 投入時に過剰なら catalogue 側で調整)。
import { getSkill } from '../content/skills.js';
/**
 * `entity.itemSkills` を走査し、軸 6 archetype 4 (`cooldown-reduction`) catalogue の
 * Skill の合計 CD 短縮率を返す。`cdrRate` 未設定 (= 軸 6 archetype 4 以外) の Skill は
 * 集計対象外 (0)。
 *
 * `applyCooldownRateMod` の `layers.axis6` に渡され、`affix + axis6 + other` 合計
 * 30% でクランプ。
 */
export function getAxis6CdrLayer(entity) {
    let sum = 0;
    for (const itemSkill of entity.itemSkills) {
        const skill = getSkill(itemSkill.templateId);
        if (skill === undefined)
            continue;
        sum += readCdrRate(skill, itemSkill);
    }
    return sum;
}
/**
 * Tier 上書き優先、未設定時は `Skill.cdrRate` fallback。軸 6 archetype 4 以外は 0。
 *
 * 解決ルール (ADR 0015 §4.3.1):
 *   - `skill.cdrRate` 未設定 → 0 (集計対象外)
 *   - `itemSkill.tier` 設定済 + `values[tier]` 設定済 → `values[tier]` 優先
 *   - それ以外 (tier 未設定 or values 配列範囲外) → `skill.cdrRate` fallback
 */
export function readCdrRate(skill, itemSkill) {
    if (skill.cdrRate === undefined)
        return 0;
    const tier = itemSkill.tier;
    if (tier !== undefined) {
        const v = itemSkill.values[tier];
        if (v !== undefined)
            return v;
    }
    return skill.cdrRate;
}
//# sourceMappingURL=cd-layers.js.map